import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
const InfoBox = ({ color = '#fff', backgroundColor = '#00a19a', icon, textContent, }) => {
    return (_jsxs("div", { className: `info-box${icon ? ' has-icon' : ''}`, style: { backgroundColor, color }, children: [icon && _jsx("div", { className: "info-box-icon", children: icon }), _jsx("div", { className: "info-box-text-content title--2", children: textContent })] }));
};
export default InfoBox;
